import { render, staticRenderFns } from "./create_business_account3.vue?vue&type=template&id=27758286&scoped=true"
import script from "./create_business_account3.vue?vue&type=script&lang=js"
export * from "./create_business_account3.vue?vue&type=script&lang=js"
import style0 from "./create_business_account3.vue?vue&type=style&index=0&id=27758286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27758286",
  null
  
)

export default component.exports